export default {
    apiMaster: 'https://master.checkstore.app',
    api: 'https://apiatendimento.checkstore.app'
}